<template>
  <div class="location-link">
    <LocationIcon
      v-if="showIcon"
      class="location-link__icon"
      variant="light"
    />
    <span
      :class="['location-link__info', { 'location-link__info--with-icon': showIcon }]"
      @click.stop="navigate"
    >
      {{ label }}
    </span>
  </div>
</template>

<script lang="ts">
import LocationIcon from './icons/Location.icon.vue'

import { useLocation } from '@/core/composable/shared/useLocation'
import { type SpaLocation } from '~/core/ts/entity/Spa'

export default defineNuxtComponent({
  components: {
    LocationIcon
  },
  props: {
    location: {
      type: Object as PropType<SpaLocation>,
      required: true,
    },
    showIcon: {
      type: Boolean,
      default: () => false,
    },
    displayFullAddress: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { locationLabel, fullAddressLabel, externalMapLink } = useLocation(props.location)

    const label = (() => {
      if (props.displayFullAddress) {
        return fullAddressLabel
      }

      return locationLabel
    })()

    function navigate() {
      window.open(externalMapLink, '_blank')
    }

    return {
      navigate,
      label,
      externalMapLink,
    }
  },
})
</script>

<style lang="scss" scoped>
.location-link {
  @apply flex items-center;

  &__info {
    @apply italic text-sm;
    @apply text-spl-gray-4;
    @apply py-1;
    @apply underline;

    &--with-icon {
      @apply ml-4;
    }
  }
}
</style>
